export type TextPlaceholders = {
  [key: string]: string
}

export interface TextFieldProps {
  value?: string
  placeholders?: TextPlaceholders
}

const replacePlaceholder = (
  value: string,
  placeholder: string,
  replacement: string
) => {
  return value.replaceAll(`{${placeholder}}`, replacement)
}

const replacePlaceholders = (value: string, placeholders: TextPlaceholders) => {
  return Object.keys(placeholders).reduce((acc, placeholder) => {
    return replacePlaceholder(acc, placeholder, placeholders[placeholder])
  }, value)
}

const SanityTextField = ({ placeholders, value }: TextFieldProps) => {
  if (!value) {
    return <></>
  }
  return <>{placeholders ? replacePlaceholders(value, placeholders) : value}</>
}

export default SanityTextField
